import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { useSelector } from "react-redux";
import CountUp from "react-countup";
import AnalyticsChart from "./AnalyticsChart";

const CountUpComponent = ({ end }) => {
    return <CountUp start={0} end={end || 0} duration={2} separator="," />;
};

const StatWidget = ({ label, value, icon, color = "primary", isCurrency = false }) => {
    return (
        <Col xl={3} md={6}>
            <Card className="card-animate">
                <CardBody style={{ height: "100px", overflow: "hidden" }}>
                    <div className="d-flex align-items-center counter-widget">
                        <div className="flex-grow-1">
                            <p className="text-uppercase fw-semibold fs-14 text-muted mb-1">
                                {label}
                            </p>
                            <h2 className="mb-0">
                                {isCurrency ? (
                                    <span>₹<CountUpComponent end={value || 0} /></span>
                                ) : (
                                    <CountUpComponent end={value || 0} />
                                )}
                            </h2>
                        </div>
                        <div className="avatar-sm flex-shrink-0">
                            <span className={`avatar-title text-${color} rounded-circle fs-3`} style={{ backgroundColor: '#f5f5f5' }}>
                                <i className={icon}></i>
                            </span>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

const StaticView = () => {
    const { dashboardData } = useSelector((state) => ({
        dashboardData: state.Dashboard.data || {},
    }));

    return (
        <div className="static-view">
            <Row>
                <StatWidget
                    key="total-users"
                    label="Total Users"
                    value={dashboardData.totalUsers || 0}
                    icon="las la-users"
                    color="primary"
                />
                <StatWidget
                    key="total-farmhouses"
                    label="Total Farmhouses"
                    value={dashboardData.totalFarmhouses || 0}
                    icon="las la-home"
                    color="info"
                />
                <StatWidget
                    key="total-bookings"
                    label="Total Bookings"
                    value={dashboardData.totalBookings || 0}
                    icon="las la-calendar-check"
                    color="success"
                />
                <StatWidget
                    key="total-income"
                    label="Total Income"
                    value={dashboardData.totalIncome || 0}
                    icon="las la-rupee-sign"
                    color="warning"
                    isCurrency={true}
                />
            </Row>

            <Row>
                <Col lg={12}>
                    <AnalyticsChart />
                </Col>
            </Row>
        </div>
    );
};

export default StaticView;
